import { Link } from "react-router-dom";
import { AMAZON_URL, KINDLE_URL, EMAILS } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-20 md:pt-24 pb-12"
      style={{
        backgroundColor: "var(--paper)",
        borderTop: "1px solid var(--rule)",
      }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 md:gap-16">
          <div>
            <p className="overline mb-6">The book</p>
            <ul className="flex flex-col gap-3 font-serif-lit text-lg">
              <li>
                <a
                  href={AMAZON_URL}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-amazon-link"
                  className="literary-link"
                  style={{ color: "var(--ink)" }}
                >
                  Buy on Amazon
                </a>
              </li>
              <li>
                <a
                  href={KINDLE_URL}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-kindle-link"
                  className="literary-link"
                  style={{ color: "var(--ink)" }}
                >
                  Buy on Kindle
                </a>
              </li>
              <li>
                <Link
                  to="/book#sample"
                  data-testid="footer-first-chapter-link"
                  className="literary-link"
                  style={{ color: "var(--ink)" }}
                >
                  Read a sample
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="overline mb-6">Connect</p>
            <ul className="flex flex-col gap-3 font-serif-lit text-lg">
              <li>
                <a
                  href={`mailto:${EMAILS.general}`}
                  data-testid="footer-email-link"
                  className="literary-link"
                  style={{ color: "var(--ink)" }}
                >
                  Email: {EMAILS.general}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="overline mb-6">Site</p>
            <ul className="flex flex-col gap-3 font-serif-lit text-lg">
              <li>
                <Link
                  to="/about"
                  data-testid="footer-about-link"
                  className="literary-link"
                  style={{ color: "var(--ink)" }}
                >
                  About Rahul
                </Link>
              </li>
              <li>
                <Link
                  to="/press"
                  data-testid="footer-press-link"
                  className="literary-link"
                  style={{ color: "var(--ink)" }}
                >
                  Press &amp; Media
                </Link>
              </li>
              <li>
                <Link
                  to="/contact#bookclubs"
                  data-testid="footer-bookclubs-link"
                  className="literary-link"
                  style={{ color: "var(--ink)" }}
                >
                  Book clubs
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-contact-link"
                  className="literary-link"
                  style={{ color: "var(--ink)" }}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="mt-16 md:mt-20 pt-8 flex items-center justify-between"
          style={{ borderTop: "1px solid var(--rule)" }}
        >
          <span
            data-testid="footer-copyright"
            className="font-nav uppercase tracking-[0.22em] text-[0.7rem]"
            style={{ color: "var(--ink-soft)" }}
          >
            © {year} Rahul Bhaskar. All rights reserved.
          </span>
          <span
            data-testid="footer-location"
            className="font-nav uppercase tracking-[0.22em] text-[0.7rem] hidden sm:inline"
            style={{ color: "var(--ink-soft)" }}
          >
            California
          </span>
        </div>
      </div>
    </footer>
  );
}
